import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-6" };
const _hoisted_5 = { class: "mb-3" };
const _hoisted_6 = { class: "form-check form-switch" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "mb-3" };
const _hoisted_9 = { class: "mb-3" };
const _hoisted_10 = { class: "col-md-6" };
const _hoisted_11 = { class: "mb-3" };
const _hoisted_12 = { class: "form-check form-switch" };
const _hoisted_13 = {
    key: 0,
    class: "mb-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "card-title fw-bold mb-15" }, "Configuration Parrainage & Fidélité", -1)),
            _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.saveConfiguration && _ctx.saveConfiguration(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "enableReferral",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.config.enableReferral) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.config.enableReferral]
                                ]),
                                _cache[6] || (_cache[6] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "enableReferral"
                                }, " Activer le parrainage ", -1))
                            ])
                        ]),
                        (_ctx.config.enableReferral)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _cache[7] || (_cache[7] = _createElementVNode("label", {
                                        for: "referralPointsReferee",
                                        class: "form-label"
                                    }, " Points Filleul (à l'inscription) ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "referralPointsReferee",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.config.referralPointsReferee) = $event)),
                                        min: "0"
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            _ctx.config.referralPointsReferee,
                                            void 0,
                                            { number: true }
                                        ]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[8] || (_cache[8] = _createElementVNode("label", {
                                        for: "referralPointsReferrer",
                                        class: "form-label"
                                    }, " Points Parrain (1ère commande filleul) ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "referralPointsReferrer",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.config.referralPointsReferrer) = $event)),
                                        min: "0"
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            _ctx.config.referralPointsReferrer,
                                            void 0,
                                            { number: true }
                                        ]
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "enableLoyalty",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.config.enableLoyalty) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.config.enableLoyalty]
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "enableLoyalty"
                                }, " Activer la fidélité ", -1))
                            ])
                        ]),
                        (_ctx.config.enableLoyalty)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _cache[10] || (_cache[10] = _createElementVNode("label", {
                                    for: "loyaltyRate",
                                    class: "form-label"
                                }, " Taux de fidélité ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control",
                                    id: "loyaltyRate",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.config.loyaltyRate) = $event)),
                                    step: "0.1",
                                    min: "0"
                                }, null, 512), [
                                    [
                                        _vModelText,
                                        _ctx.config.loyaltyRate,
                                        void 0,
                                        { number: true }
                                    ]
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex justify-content-end mt-4" }, [
                    _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary text-white"
                    }, [
                        _createElementVNode("i", { class: "flaticon-save me-2" }),
                        _createTextVNode(" Enregistrer ")
                    ])
                ], -1))
            ], 32)
        ])
    ]));
}
